export default "__VITE_ASSET__DVHs98Cd__"